const getColorByDeviceIndex = (deviceId: number, colors: string[]) => {
  const index = deviceId % colors.length;
  return colors[index];
};

export default getColorByDeviceIndex;
